import { Alert, Button, PasswordInput, Stack, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { FormEvent, useState } from 'react';
import { api } from '../api';

/** Смена своего пароля: в окне из меню и на экране после временного пароля. */
export function ChangePasswordForm({ onDone, currentLabel = 'Текущий пароль' }: { onDone: () => void | Promise<void>; currentLabel?: string }) {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [repeat, setRepeat] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (next.length < 10) return setError('Новый пароль — не короче 10 символов');
    if (next !== repeat) return setError('Пароли не совпадают');
    setBusy(true);
    setError(null);
    try {
      await api.post('/auth/password', { current_password: current, new_password: next });
      notifications.show({ color: 'brand', message: 'Пароль изменён' });
      await onDone();
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <form onSubmit={submit}>
      <Stack gap="md">
        {error && (
          <Alert color="red" variant="light" role="alert">
            {error}
          </Alert>
        )}
        <PasswordInput label={currentLabel} autoComplete="current-password" required value={current} onChange={(e) => setCurrent(e.currentTarget.value)} />
        <PasswordInput label="Новый пароль" autoComplete="new-password" required value={next} onChange={(e) => setNext(e.currentTarget.value)} />
        <PasswordInput label="Новый пароль ещё раз" autoComplete="new-password" required value={repeat} onChange={(e) => setRepeat(e.currentTarget.value)} />
        <Text size="xs" c="dimmed">
          Не короче 10 символов. Удобно взять фразу из нескольких слов.
        </Text>
        <Button type="submit" loading={busy}>
          Сменить пароль
        </Button>
      </Stack>
    </form>
  );
}
